// Attention!
// Do not edit directly! The hardcoded values of these tokens are token references
// that get resolved when the .js/d.ts files are being generated from the token JSON files.
export const SYS_SHADOW_ELEVATION_LEVEL2_DARK = '0 6px 6px 0 rgba(0, 0, 0, 0.3)';
export const SYS_SHADOW_ELEVATION_LEVEL3_DARK = '0 6px 6px 0 rgba(0, 0, 0, 0.3)';
//# sourceMappingURL=box-shadow.dark.generated.js.map